import React from 'react'

import { Box, Breakpoint, Grid, GridSpan, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import {
  MarketplaceReview as ClientReview,
  ClientReviewsProps,
} from 'modules/marketplace_modules/components/Revamp/types'
import { ReviewItem } from './_Item'

const ClientReviews: React.FC<ClientReviewsProps> = ({ reviews }) => {
  const gridColSpan: { [key in Breakpoint]?: GridSpan } = {
    xxs: 12,
    s: 6,
  }

  const validReviews = reviews?.filter((review) => Boolean(review.title)) || []

  if (validReviews.length === 0) {
    return null
  }

  return (
    <Box paddingY="s24">
      <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
        <Text size="300" weight="semibold" color="black">
          {i18n.t('marketplace.revamp.reviews')}
        </Text>
      </Box>
      <Box paddingY="s24">
        <Grid variant="fixed">
          {validReviews.map((review) => (
            <Box key={review.title} gridColSpan={gridColSpan}>
              <ReviewItem review={review} />
            </Box>
          ))}
        </Grid>
      </Box>
    </Box>
  )
}

export default ClientReviews
export type { ClientReview }
